module.exports = __webpack_public_path__ + "static/media/ck.22f9649a.svg";